import { OrganizationSwitcher, UserButton, useCurrentOrg } from '@develio/auth/client';

/**
 * Top navigation bar. Shows the active organization switcher (via Clerk's
 * built-in component) and the user menu on the right. Sprint 21 adds true
 * multi-org support; Sprint 5 just relies on Clerk's default org switcher.
 */
export function TopBar() {
  const currentOrg = useCurrentOrg();

  return (
    <header className="flex h-14 items-center justify-between border-b border-slate-200 bg-white px-6">
      <div className="flex items-center gap-3">
        <OrganizationSwitcher
          hidePersonal
          appearance={{
            elements: {
              rootBox: 'text-sm',
            },
          }}
        />
        {currentOrg && (
          <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
            {currentOrg.role}
          </span>
        )}
      </div>
      <div className="flex items-center gap-3">
        <UserButton
          appearance={{
            elements: {
              avatarBox: 'h-8 w-8',
            },
          }}
        />
      </div>
    </header>
  );
}
